import styled from 'styled-components'
import theme from '@app/ui/theme'

export const ModalBackdrop = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
`

export const ModalContentWrapper = styled.div<{
  $width: string
  $height: string
}>`
  background-color: ${theme.colors.white};
  border-radius: 12px;
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  position: relative;
`

export const ModalScrollContent = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`

export const CloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 20px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  z-index: 10;

  &:hover {
    background-color: #f0f0f0;
    color: #333;
  }
`

export const ModalHeader = styled.div`
  flex-shrink: 0;
  padding: 16px 48px 0px 16px;
  min-height: 56px;
`

export const ModalFooter = styled.div`
  flex-shrink: 0;
  padding: 16px;
  border-top: 1px solid #e4e4e4;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`
